<button
  class="rounded-lg border-2 border-dashed p-[2.5rem] text-center cursor-pointer select-none w-full bg-vinciBlue-25"
  [class]="isDragging() ? 'border-vinciBlue-500' : 'border-vinciBlue-300'"
  role="button"
  (click)="openFileDialog()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <icon [name]="'plus-circle'" [size]="'1.75rem'" class="pb-[0.75rem]"></icon>
  <p class="underline">{{ 'documents.addDocuments' | transloco }}</p>
</button>

<input
  #fileInput
  type="file"
  class="hidden"
  [attr.multiple]="multiple() ? '' : null"
  accept=".pdf"
  (change)="onFileInput($event)"
/>
